import { __awaiter, __generator } from "tslib";
import { createGroupIdentifyEvent, createIdentifyEvent, createTrackEvent, createRevenueEvent, createGroupEvent, } from './utils/event-builder';
import { Timeline } from './timeline';
import { buildResult } from './utils/result-builder';
var AmplitudeCore = /** @class */ (function () {
    function AmplitudeCore(name) {
        if (name === void 0) { name = '$default'; }
        this.logEvent = this.track.bind(this);
        this.name = name;
    }
    // NOTE: Do not use `_apiKey` and `_userId` here
    AmplitudeCore.prototype.init = function (_apiKey, _userId, config) {
        this.config = config;
        this.timeline = new Timeline();
        return Promise.resolve();
    };
    AmplitudeCore.prototype.track = function (eventInput, eventProperties, eventOptions) {
        var event = createTrackEvent(eventInput, eventProperties, eventOptions);
        return this.dispatch(event);
    };
    AmplitudeCore.prototype.identify = function (identify, eventOptions) {
        var event = createIdentifyEvent(identify, eventOptions);
        return this.dispatch(event);
    };
    AmplitudeCore.prototype.groupIdentify = function (groupType, groupName, identify, eventOptions) {
        var event = createGroupIdentifyEvent(groupType, groupName, identify, eventOptions);
        return this.dispatch(event);
    };
    AmplitudeCore.prototype.setGroup = function (groupType, groupName) {
        var event = createGroupEvent(groupType, groupName);
        return this.dispatch(event);
    };
    AmplitudeCore.prototype.revenue = function (revenue, eventOptions) {
        var event = createRevenueEvent(revenue, eventOptions);
        return this.dispatch(event);
    };
    AmplitudeCore.prototype.add = function (plugin) {
        return __awaiter(this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_a) {
                config = this.config;
                return [2 /*return*/, this.timeline.register(plugin, config)];
            });
        });
    };
    AmplitudeCore.prototype.remove = function (pluginName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.timeline.deregister(pluginName)];
            });
        });
    };
    AmplitudeCore.prototype.dispatch = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_1, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.timeline.push(event, this.config)];
                    case 1:
                        result = _a.sent();
                        if (result.code === 200) {
                            this.config.loggerProvider.log(result.message);
                        }
                        else {
                            this.config.loggerProvider.error(result.message);
                        }
                        return [2 /*return*/, result];
                    case 2:
                        e_1 = _a.sent();
                        message = String(e_1);
                        this.config.loggerProvider.error(message);
                        return [2 /*return*/, buildResult(event, 0, message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AmplitudeCore.prototype.setOptOut = function (optOut) {
        var config = this.config;
        config.optOut = Boolean(optOut);
    };
    AmplitudeCore.prototype.flush = function () {
        return this.timeline.flush();
    };
    return AmplitudeCore;
}());
export { AmplitudeCore };
//# sourceMappingURL=core-client.js.map